export default __webpack_public_path__ + "static/rafe-colburn-b7689ff165c5c4c3227e0ee1cbdeb4a6.jpg";